import { genericOAuthClient, passkeyClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { useMemo } from "react";

import { useAppConfig } from "./config";

// React hook to get the auth client
export function useAuthClient() {
	const config = useAppConfig();

	return useMemo(() => {
		return createAuthClient({
			baseURL: config.apiUrl + "/auth",
			// genericOAuthClient enables signIn.oauth2({ providerId }) for the
			// enterprise SSO (OIDC/AD/Entra) provider configured on the server.
			plugins: [passkeyClient(), genericOAuthClient()],
		});
	}, [config.apiUrl]);
}

// React hook for auth methods
export function useAuth() {
	const authClient = useAuthClient();

	return useMemo(
		() => ({
			signIn: authClient.signIn,
			signUp: authClient.signUp,
			signOut: authClient.signOut,
			useSession: authClient.useSession,
			getSession: authClient.getSession,
			forgetPassword: authClient.forgetPassword,
			resetPassword: authClient.resetPassword,
		}),
		[authClient],
	);
}
